/**
 * RoyaltyPaymentNotice
 *
 * Shared, content-only banner for the royalty payout notice. Renders the copy;
 * callers supply their own wrapper (card/border/width) via `className`.
 *
 * Planning: C:/Users/User/.claude/plans/load-gag-skills-for-curried-codd.md
 */
import banners from "static-data/banners";

// WHY: Deliberately one shared component, not copy-pasted text. Every page that
// shows the notice renders this, so the wording stays identical and a copy change
// is a single edit in static-data/banners.js.
export default function RoyaltyPaymentNotice({ className = "" }) {
  return (
    <div className={className}>
      <p className="text-sm text-gray-700 leading-relaxed">
        {banners.royaltyNotice}
      </p>
    </div>
  );
}
